<p-card>
  <ng-template pTemplate="header">
    <div class="p-4">
      <h3>{{ "i18n.core.navigation.editProfile" | translate }}</h3>
    </div>
  </ng-template>

  <div class="p-fluid">
    <app-user-edit-form [form]="userEditForm"></app-user-edit-form>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end">
      <p-button
        [label]="'i18n.shared.save' | translate"
        (onClick)="save()"
        [disabled]="!userEditForm.valid"
        icon="pi pi-save"
        severity="primary"
      ></p-button>
    </div>
  </ng-template>
</p-card>